import {chemicalBaseTypes, propertyTypes} from 'helpers/constants';

export const usPartialDrains = ({analysis, products, pool, formatMessage, sanitizerType}) => {
  let pHBuffer = '';

  if (products.length > 0 && pool && pool.pHBuffer) {
    let buffers = products.filter(x => x.id === pool.pHBuffer);

    if (buffers.length > 0) {
      pHBuffer = buffers[0].name;
    }
  }

  if (
    [
      chemicalBaseTypes.brominePool,
      chemicalBaseTypes.chlorinePool,
      chemicalBaseTypes.mineralSpringsPool,
      chemicalBaseTypes.saltWaterPool,
    ].indexOf(sanitizerType) !== -1 && (
      analysis.cYA > 100 && !analysis.startup && pool.property === 'C' ||
      analysis.cYA > 200 && !analysis.startup && pool.property === 'R' ||
      analysis.cYA > 150 && analysis.startup && pool.property === 'R' ||
      analysis.cYA > 50 && analysis.startup && pool.property === 'C' ||
      analysis.cYA > 30 && sanitizerType === chemicalBaseTypes.brominePool)) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.partial.drain.cya'}),
    };
  }

  if (sanitizerType === chemicalBaseTypes.mineralSpringsPool && analysis.optimizerPlusBorate > 50 && analysis.startup ||
    analysis.optimizerPlusBorate > 90) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.partial.drain.borate'}),
    };
  }

  if (sanitizerType === chemicalBaseTypes.mineralSpringsPool && analysis.minerals < 2600 && !analysis.startup) {
    let beginnings = (pool.idealSaltPPM - analysis.minerals) / 108 * pool.volume;
    let borateIncrease = Math.ceil(beginnings / pool.volume * 1.15);
    let newBorate = borateIncrease + parseFloat(analysis.optimizerPlusBorate);

    if (newBorate > 90) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.borate'}),
      };
    }
  }

  if (sanitizerType === chemicalBaseTypes.mineralSpringsPool && pool.idealSaltPPM &&
    analysis.minerals > pool.idealSaltPPM * 1.1) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.partial.drain.minerals'}),
    };
  }

  if (analysis.tDS > 2500 && pool.volume > 1000 && sanitizerType !== chemicalBaseTypes.mineralSpringsPool &&
    sanitizerType !== chemicalBaseTypes.saltWaterPool) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.partial.drain.tds'}),
    };
  }

  if (analysis.tDS > 2500 && pool.volume > 1000 && sanitizerType !== chemicalBaseTypes.mineralSpringsPool &&
    sanitizerType !== chemicalBaseTypes.saltWaterPool) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.complete.drain.tds'}),
    };
  }

  // Spa drains
  if ([chemicalBaseTypes.chlorineSpa, chemicalBaseTypes.bromineSpa, chemicalBaseTypes.softSoakSpa].indexOf(sanitizerType) !== -1) {
    if (analysis.tDS > 2500 && sanitizerType !== chemicalBaseTypes.saltWaterSpa) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.tds.too.high'}),
      };
    }

    if (pool.property === propertyTypes.commercial && analysis.cYA > 100 ||
      pool.property === propertyTypes.residential && analysis.cYA > 200) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.cya.too.high'}),
      };
    }
  }

  if (analysis.cDDistStandard !== null && analysis.cDDistStandard !== undefined && isFinite(analysis.cDDistStandard) &&
    (analysis.cDSample !== null && analysis.cDSample !== undefined && isFinite(analysis.cDSample))) {
    let cdDiff = analysis.cDDistStandard - analysis.cDSample;

    if (parseInt(analysis.testType) === 1 && cdDiff > 3 || parseInt(analysis.testType) === 2 && cdDiff * 14.8 > 100) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.chlorine'}),
      };
    }

    if (pool.volume <= 2500 && cdDiff > 0) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.complete.drain.chlorine'}),
      };
    }
  }

  if (pHBuffer === 'Spa Sentry' && !analysis.spaSentryStartup && analysis.pH > 7.6 && analysis.hardness >= 50) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.total.harndess.ph'}),
    };
  }

  return {
    partialDrainVisible: false,
    partialDrainMessage: '',
  };
};

export const canadaPartialDrains = ({sanitizerType, pool, analysis, dealer, formatMessage}) => {
  const {volume} = pool;

  if ([chemicalBaseTypes.chlorinePool, chemicalBaseTypes.brominePool, chemicalBaseTypes.synergyPool].includes(sanitizerType)) {
    if (analysis.tDS > 2500) {
      if (volume > 9500) {
        return {
          partialDrainVisible: true,
          partialDrainMessage: formatMessage({id: 'scanning.partial.drain.tds'}),
        };
      }

      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.complete.drain.tds'}),
      };
    }


    if (sanitizerType === chemicalBaseTypes.brominePool && analysis.cYA > 30 && !dealer.disableDrainPopBromide ||
      [chemicalBaseTypes.chlorinePool, chemicalBaseTypes.synergyPool].includes(sanitizerType) &&
        analysis.cYA > 100 && pool.property === propertyTypes.commercial ||
      [chemicalBaseTypes.chlorinePool, chemicalBaseTypes.synergyPool].includes(sanitizerType) &&
        analysis.cYA > 200 && pool.property === propertyTypes.residential) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.cya'}),
      };
    }

    if (pool.usingOptimizerPlus && volume > 9500 && analysis.optimizerPlusBorate > 90) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.borate'}),
      };
    }
  }

  if ([chemicalBaseTypes.chlorineSpa, chemicalBaseTypes.bromineSpa,
    chemicalBaseTypes.synergySpa, chemicalBaseTypes.saltWaterSpa].includes(sanitizerType) && analysis.tDS > 2500) {
    return {
      partialDrainVisible: true,
      partialDrainMessage: formatMessage({id: 'scanning.complete.drain.tds'}),
    };
  }

  if ([chemicalBaseTypes.mineralSpringsPool, chemicalBaseTypes.saltWaterPool].includes(sanitizerType)) {
    if (analysis.cya > 150 && (analysis.startup || analysis.freshFill) && pool.property === propertyTypes.residential ||
      analysis.cya > 50 && (analysis.startup || analysis.freshFill) && pool.property === propertyTypes.commercial ||
      analysis.cya > 200 && pool.property === propertyTypes.residential ||
      analysis.cya > 100 && pool.property === propertyTypes.commercial) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.cya'}),
      };
    }

    if (sanitizerType === chemicalBaseTypes.mineralSpringsPool && pool.usingOptimizerPlus &&
      analysis.optimizerPlusBorate > 50 && (analysis.startup || analysis.freshFill) ||
      pool.usingOptimizerPlus && analysis.optimizerPlusBorate > 90) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.borate'}),
      };
    }

    if (analysis.salt > pool.idealSaltPPM * 1.1) {
      return {
        partialDrainVisible: true,
        partialDrainMessage: formatMessage({id: 'scanning.partial.drain.minerals'}),
      };
    }
  }

  return {
    partialDrainVisible: false,
    partialDrainMessage: '',
  };
};

export default ({dealer, analysis, pool, products, formatMessage, sanitizerType}) => {
  if (dealer.country === 'CA') {
    return canadaPartialDrains({sanitizerType, pool, products, analysis, dealer, formatMessage});
  }

  return usPartialDrains({sanitizerType, pool, products, analysis, formatMessage});
};
